import type { FaireProductEntity } from "../../entity_types/product";

export const p_xtgzqyq5qf: FaireProductEntity = {
  token: "p_xtgzqyq5qf",
  type: "product",
  name: "Run Around the Sun Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl: "https://cdn.faire.com/fastly/e8758b2192e560698f895de43bce510fb1f188ec054c67ecd61fb7344cadfc99.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b598022a5457bc9e1f8e1f91d5171173045088580067065bde337362d55c8307.webp",
    "https://cdn.faire.com/fastly/372273c8c76e4d609bd66e7ae17129709d824886cb5efc3bae1ba73b8459b738.png"
  ],
  priceDollars: 3,
  description: "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:16.852Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
